import { SVGProps } from 'react'

export const CompareIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="18"
    viewBox="0 0 16 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.08331 13.1667H14.4166M14.4166 13.1667L11.0833 9.83333M14.4166 13.1667L11.0833 16.5M14.4166 4.83333H1.08331M1.08331 4.83333L4.41665 1.5M1.08331 4.83333L4.41665 8.16667"
      stroke="#475467"
      strokeWidth="1.66667"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
